import React, {useEffect, useMemo, useState} from 'react';

import {UserListLookupForm} from './UserListLookupForm';
import {useGetUserListDataQuery} from '~/store/rtkQuery';
import {Users} from '~/modules/api';

export const UserListLookup = () => {
  const [searchBy, setSearchBy] =
    useState<Users.UserListParams['type']>('userIds');
  const [userListInput, setUserListInput] = useState<string[]>([]);

  const findUserData = (userData: string[]) => {
    setUserListInput(userData);
  };

  const {data, isLoading, error} = useGetUserListDataQuery({
    userData: userListInput,
    type: searchBy,
  });

  const userList = data?.response.values;
  const notFound = useMemo(() => {
    return data?.response.notFound;
  }, [data]);

  const tableColumns = [{label: 'Email'}, {label: 'UserId'}];
  return (
    <div className="p-5">
      <h1 className="text-5xl text-center font-semibold">User List Lookup</h1>
      <div className="flex flex-col justify-center items-center pt-5 gap-6">
        <div className="join">
          <input
            className="join-item btn"
            type="radio"
            name="searchOptions"
            value="userIds"
            id="userIds"
            checked={searchBy === 'userIds'}
            aria-label="User Ids"
            onChange={e => setSearchBy('userIds')}
          />
          <input
            className="join-item btn"
            type="radio"
            name="searchOptions"
            value="emails"
            id="emails"
            checked={searchBy === 'emails'}
            aria-label="Emails"
            onChange={e => setSearchBy('emails')}
          />
        </div>
        <div className="flex-row text-center">
          <div className="flex flex-col">
            <p className="font-medium pb-2">
              Enter user information below to look them up
            </p>
            <UserListLookupForm
              findUserData={findUserData}
              type={searchBy}
              isLoading={isLoading}
            />
          </div>
          {isLoading && <p className="pb-2">Searching...</p>}
          {error && <p className="pb-2 text-red-600">{error.message}</p>}
        </div>
      </div>
      {!!notFound?.length && (
        <p className="pb-2 text-purple-600">
          {notFound?.length} users could not be found in database
        </p>
      )}
      <div className="overflow-x-auto">
        <table className="table table-zebra">
          <thead>
            <tr>
              {tableColumns.map(({label}) => {
                return <th key={label}>{label}</th>;
              })}
            </tr>
          </thead>

          <tbody>
            {userList &&
              userList.map(user => {
                return (
                  <tr>
                    <td>{user.email}</td>
                    <td>{user.userId}</td>
                  </tr>
                );
              })}
            {notFound &&
              notFound.map(user => {
                return (
                  <tr>
                    <td>{user.email ? user.email : 'not found'}</td>
                    <td>{user.uid ? user.uid : 'not found'}</td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
    </div>
  );
};
